import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { ALL_LOCALES } from './i18n/locales';
import { bootLocale } from './i18n/localePreference';

// No LanguageDetector: localePreference.ts + LocaleProvider ARE the detection
// chain, and browser language is deliberately not part of it (the shop's
// default outranks it). See docs/TRANSLATIONS.md.
i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: bootLocale(),
    fallbackLng: 'en',
    supportedLngs: [...ALL_LOCALES],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18next;
